<template>
  <div class="product-configurator">
    <div class="product-configurator__container">
      <div class="flex-row">
        <div class="w-full md:w-1/2 flex-col">
          <div class="product-configurator__player">
            <div id="player" class="mb-10 bg-gray-light border-1 border-gray-medium ">
            </div>
            <loading :active.sync="isPlayerLoading"
                     :can-cancel="false"
                     :opacity="0"
                     color="#2C9199"
                     :z-index="5"
                     :is-full-page="false"></loading>
          </div>
        </div>
        <div class="w-full md:w-1/2 flex-col">
          <div class="product-configurator__mobile-warning">*Desktop is recommended for the best configurator experience</div>
          <div class="product-configurator__content" :class="{'disabled': !loaded}">
            <div class="product-configurator__heading">
              <h1 v-html="headline"></h1>
            </div>
            <div v-if="invalidSelection" class="product-configurator__invalid">
              Unavailable
            </div>

            <div v-if="!invalidSelection" class="product-configurator__price">$<span
                v-text="formatMoney(totalPrice)"></span></div>
            <div class="product-configurator__attributes">
              <div v-for="attr in sortedAttributes">

                <!-- Main Attributes -->
                <div class="product-configurator__attribute"
                     v-if="attr.type === 'main' && hiddenAttributes.indexOf(attr.name) === -1">
                  <div class="product-configurator__attribute__title">
                    <span>{{ attr.label }}</span>: <span
                      class="product-configurator__attribute__title__option-value">{{
                      getSelectedAttribute(attr.name)
                    }}</span>
                  </div>
                  <div>
                    <div v-if="config.imgAttributes.indexOf(attr.name) !== -1">
                      <div class="product-configurator__attribute__values">
                        <div v-for="(val,key) in getAttrValues(attr.name,attr.values)">
                          <div
                              v-if="val.img && (!hiddenAttributeValuesMapped[(attr.name)] || hiddenAttributeValuesMapped[(attr.name)].indexOf(val.value) === -1)">
                            <div class="product-configurator__attribute__value img-value"
                                 :aria-label="val"

                                 :class="{'active': config.attributes[attr.name] && config.attributes[attr.name].selected === val.value}"
                                 @click="() => setOption(attr.name,val.value)">
                              <div class="product-configurator__attribute__value__img"
                                   :style="`background-image: url(${val.img})`"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="config.imgAttributes.indexOf(attr.name) == -1">
                      <div class="product-configurator__attribute__values">
                        <template v-for="val in getAttrValues(attr.name,attr.values)">
                          <div class="product-configurator__attribute__value"
                               v-if="!hiddenAttributeValuesMapped[(attr.name)] || hiddenAttributeValuesMapped[(attr.name)].indexOf(val.value) === -1"
                               :class="{'active': config.attributes[attr.name] && config.attributes[attr.name].selected === val.value}"
                               @click="() => setOption(attr.name,val.value)"
                               style="text-transform: none"
                               v-text="getAttributeLabel(val.label,attr.name,val.value)">
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Main Attributes (Multi Attributes) -->

                <div class="product-configurator__attribute"
                     v-else-if="attr.type === 'mainMulti' && hiddenAttributes.indexOf(attr.name) === -1">
                  <div class="product-configurator__attribute__title">
                    <span>{{ attr.label }}</span>: <span
                      class="product-configurator__attribute__title__option-value">
                    {{
                      getSelectedAttributeMulti(attr.name)
                    }}
                  </span>
                  </div>
                  <div>
                    <div>
                      <div class="product-configurator__attribute__values">
                        <template v-for="(val,key) in attr.options">
                          <div class="product-configurator__attribute__value"
                               v-if="!hiddenAttributeValuesMapped[(attr.name)] || hiddenAttributeValuesMapped[(attr.name)].indexOf(val.value) === -1"
                               :class="{'active': config.multiAttributes[attr.name] && config.multiAttributes[attr.name].selected === val.value}"
                               @click="() => setMultiOption(attr.name,val.value,val.values)"
                               style="text-transform: none">
                            {{ val.label }}
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Option Attributes -->

                <div class="product-configurator__attribute"
                     v-else-if="attr.type === 'option' && hiddenAttributes.indexOf(attr.name) === -1 && invalidVariantAttributes.indexOf(attr.name) == -1">
                  <div class="product-configurator__attribute__title">
                    <span>{{ attr.label }}: </span><span
                      class="product-configurator__attribute__title__option-value">{{
                      getSelectedAttributeOption(attr.name)
                    }}</span>
                  </div>
                  <div>

                    <div class="product-configurator__attribute__values">
                      <div v-if="attr.isImgAttribute">
                        <template v-for="val in attr.options">
                          <div class="product-configurator__attribute__value img-value"
                               v-if="!hiddenAttributeValuesMapped[(attr.name)] || hiddenAttributeValuesMapped[(attr.name)].indexOf(val.value) === -1"
                               :class="{'active': config.optionAttributes[attr.name] && config.optionAttributes[attr.name].selected === val.value}"
                               @click="() => setBasicOption(attr.name,val.value)"
                               style="text-transform: none">
                            <div class="product-configurator__attribute__value__img"
                                 :style="`background-image: url(${val.img})`"></div>
                          </div>
                        </template>
                      </div>
                      <div v-else>
                        <template v-for="val in attr.options">
                          <div class="product-configurator__attribute__value"
                               v-if="!hiddenAttributeValuesMapped[(attr.name)] || hiddenAttributeValuesMapped[(attr.name)].indexOf(val.value) === -1"
                               :class="{'active': config.optionAttributes[attr.name] && config.optionAttributes[attr.name].selected === val.value}"
                               @click="() => setBasicOption(attr.name,val.value)"
                               style="text-transform: none">
                            {{ val.label }}
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Add on Attributes -->

                <div class="product-configurator__attribute"
                     v-else-if="attr.type === 'addon' && hiddenAttributes.indexOf(attr.name) === -1 && invalidVariantAttributes.indexOf(attr.name) == -1">
                  <div class="product-configurator__attribute__title">
                    <span>{{ attr.label }}: </span><span
                      class="product-configurator__attribute__title__option-value">{{
                      getSelectedAttributeAddon(attr.name)
                    }}</span>
                  </div>
                  <div>
                    <div class="product-configurator__attribute__values">
                      <div v-if="config.imgAttributes.indexOf(attr.name) !== -1">
                        <template v-for="val in getAddonAttrValues(attr.name,attr.values)">
                          <div class="product-configurator__attribute__value img-value"
                               v-if="!hiddenAttributeValuesMapped[(attr.name)] || hiddenAttributeValuesMapped[(attr.name)].indexOf(val.value) === -1"
                               :class="{'active': config.addonAttributes[attr.name] && config.addonAttributes[attr.name].selected === val.value}"
                               @click="() => setAddonOption(attr.name,val.value)"
                               style="text-transform: none">
                            <div class="product-configurator__attribute__value__img"
                                 :style="`background-image: url(${val.img})`"></div>
                          </div>
                        </template>
                      </div>
                      <div v-else>
                        <template v-for="val in getAddonAttrValues(attr.name,attr.values)">
                          <div class="product-configurator__attribute__value"
                               v-if="!hiddenAttributeValuesMapped[(attr.name)] || hiddenAttributeValuesMapped[(attr.name)].indexOf(val.value) === -1"
                               :class="{'active': config.addonAttributes[attr.name] && config.addonAttributes[attr.name].selected === val.value}"
                               @click="() => setAddonOption(attr.name,val.value)"
                               style="text-transform: none">
                            {{ val.label }}
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="invalidConfiguration" class="product-configurator__error-message">
              {{invalidConfiguration.message}}
            </div>

            <!-- Form Options -->

            <div class="product-configurator__form-actions" style="margin-top: 32px;">
              <div class="product-configurator__qty">
                <span class="product-configurator__qty__plus"
                      @click="() => { selectedQty ? selectedQty = parseInt(selectedQty) + 1 : selectedQty = 1}"> <i
                    class="far fa-plus"></i></span>
                <span class="product-configurator__qty__minus"
                      @click="() => { selectedQty > 1 ? selectedQty = parseInt(selectedQty) - 1 : selectedQty = 1} "> <i
                    class="far fa-minus"></i></span>
                <input @input="onQtyInput" v-model="selectedQty"
                       type="number" min="1" max="999"/>
              </div>
              <button :disabled="invalidSelection || invalidConfiguration" class="button button--atc"
                      data-slide-out-open-add="productConfigurator">Add To
                Estimate
              </button>
            </div>
            <!--div class="product-configurator__disclaimer">
              <span>!</span> <b>Please note:</b> We're currently updating the pricing in our configurator - please bear with us while it's going through updates! Contact our team for a precise quote.
            </div-->
          </div>
        </div>
      </div>

      <configurator-slide-out
          :selected-options="selectedOptions"
          :selected-variant-id="selectedVariantId"
          :invalid="invalidConfiguration || invalidSelection"
          :selected-variant-addon-blocks="selectedVariantAddonBlockIds"
          :csrf-token-name="csrfTokenName"
          :csrf-token-value="csrfTokenValue"
          :attributes="selectedAttributes"
          :invalid-variant-attributes="invalidVariantAttributes"
          :element-id="productId"
          :qty="selectedQty"
          handle="productConfigurator">

      </configurator-slide-out>
      <div class="fixed-items">
        <div class="current-price">Current Item Price <i>$</i><span v-text="formatMoney(totalPrice)"></span></div>

        <button class="button open-quote" data-slide-out-open="productConfigurator">View Estimate</button>
      </div>
    </div>
  </div>
</template>

<script>

import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Configurator',
  data: function () {
    return {
      isPlayerLoading: false,
      currentSelectionVariantKey: '',
      invalidSelection: false,
      config: {},
      loaded: false,
      basePrice: '',
      currentPrice: '',
      selectedVariantId: '',
      selectedVariant: '',
      selectedQty: 1,
      player: {},
      hiddenAttributes: [],
      hiddenAttributeValues: [],
      hiddenAttributeValuesMapped: {},
      defaultConfigValues: {},
      snapshot: ''
    }
  },
  props: {
    csrfTokenName: {
      Type: String
    },
    csrfTokenValue: {
      type: String
    },
    threekitProductId: {},
    productId: {},
    headline: '',
    authToken: {},
    configData: {}
  },
  mounted() {
    this.config = JSON.parse(this.configData);
    this.currentPrice = this.config.basePrice;
    this.selectedVariantId = this.config.defaultVariant.id;
    this.currentSelectionVariantKey = this.config.defaultVariant.key;
    this.init();
  },
  computed: {
    invalidVariantAttributes() {
      let allInvalidAttributes = [];

      if (this.config && this.config.invalidVariantAttributes) {
        let selectedVariantId = this.selectedVariantId;
        this.config.invalidVariantAttributes.forEach(function (invalidAttributes) {

          if (invalidAttributes.variantIds && invalidAttributes.variantIds.indexOf(selectedVariantId.toString()) !== -1) {
            allInvalidAttributes = [...allInvalidAttributes, ...invalidAttributes.attributeNames]
          }
        }, this)

      }

      return allInvalidAttributes;
    },
    invalidConfiguration() {
      let invalidConfigMatch = false;
      // Disabled
      return  invalidConfigMatch;

      if (this.config && this.config.invalidConfigurations) {
        let selectedAttributes = Object.values(this.allSelectedAttributes);
        console.log('INVALID CONFIGS:',this.config.invalidConfigurations);

        let selectedVariantId = this.selectedVariantId;
        this.config.invalidConfigurations.forEach(function (invalidConfig) {

          if (invalidConfig.variantIds && invalidConfig.variantIds.indexOf(selectedVariantId.toString()) !== -1) {
            selectedAttributes.forEach(function (selectedAttribute) {
              if (selectedAttribute.name == invalidConfig.attributeName && invalidConfig.attributeValueNames.indexOf(selectedAttribute.selected) !== -1) {
                invalidConfigMatch = invalidConfig;
              }
            });
          }
        }, this)
      }

      console.log('INVALID CONFIG:',invalidConfigMatch);

      return invalidConfigMatch;
    },
    variantsByVariantId() {
      if (this.config.variants) {
        return this.config.variants.reduce(function (map, obj) {
          map[obj.id] = obj;
          return map;
        }, {});
      } else return {};
    },
    selectedVariantAddonBlocks() {
      return this.getValidSelectedAddonGroupValues();
    },
    selectedVariantAddonBlockIds() {
      let addonBlocks = this.getValidSelectedAddonGroupValues() ?? [];
      if (addonBlocks.length) {
        return addonBlocks.map(function (addonBlock) {
          return addonBlock.blockId;
        })
      } else return [];
    },
    /**
     * Returns all attributes that are currently selected for all attribute types
     *
     * @return {}
     */
    allSelectedAttributes() {
      let attributes = {};
      this.config.sortedAttributes.forEach(function (sortedAttribute) {
        if (this.hiddenAttributes.indexOf(sortedAttribute.name) === -1) {
          let attribute = this.config.attributes[(sortedAttribute.name)] ?? this.config.multiAttributes[(sortedAttribute.name)] ?? this.config.addonAttributes[(sortedAttribute.name)] ?? this.config.optionAttributes[(sortedAttribute.name)];
          if (attribute && attribute.selected) {
            attributes = {...attributes, [attribute.name]: attribute}
          }
        }
      }.bind(this))

      return attributes;
    },
    /**
     * Returns all attributes that are required for a full selection
     *
     * @return {}
     */
    unselectedAttributes() {
      let attributes = {};
      this.config.sortedAttributes.forEach(function (sortedAttribute) {
        if (this.hiddenAttributes.indexOf(sortedAttribute.name) === -1) {
          let attribute = this.config.attributes[(sortedAttribute.name)] ?? this.config.multiAttributes[(sortedAttribute.name)] ?? this.config.addonAttributes[(sortedAttribute.name)] ?? this.config.optionAttributes[(sortedAttribute.name)];
          if (attribute && !attribute.selected) {
            attributes = {...attributes, [attribute.name]: attribute}
          }
        }
      }.bind(this))

      return attributes;
    },
    /**
     * Parse out each type of attributes into similar structures using sortedAttributes to set order of array
     * and sets type on each to use when displaying
     *
     * @return {}
     */
    sortedAttributes() {

      let attributes = {};

      if (this.config.sortedAttributes) {
        this.config.sortedAttributes.forEach(function (attribute) {

          // Main
          if (Object.keys(this.config.attributes).indexOf(attribute.name) !== -1) {
            attributes = {
              ...attributes,
              [attribute.name]: {...this.config.attributes[(attribute.name)], type: 'main'}
            };
          }

          // Multi
          if (Object.keys(this.config.multiAttributes).indexOf(attribute.name) !== -1) {
            attributes = {
              ...attributes,
              [attribute.name]: {...this.config.multiAttributes[(attribute.name)], type: 'mainMulti'}
            };
          }

          // Options
          if (Object.keys(this.config.optionAttributes).indexOf(attribute.name) !== -1) {
            attributes = {
              ...attributes,
              [attribute.name]: {...this.config.optionAttributes[(attribute.name)], type: 'option'}
            };
          }

          // Addons
          if (Object.keys(this.config.addonAttributes).indexOf(attribute.name) !== -1) {
            attributes = {
              ...attributes,
              [attribute.name]: {...this.config.addonAttributes[(attribute.name)], type: 'addon'}
            };
          }

        }, this);
      }

      return attributes;
    },
    totalPrice() {
      let totalAddonPrice = 0;
      if (this.selectedVariantId) {
        let selectedAddonGroupValues = this.getValidSelectedAddonGroupValues();
        console.log('Selected Addon Groups: ', selectedAddonGroupValues);

        if (selectedAddonGroupValues.length) {
          selectedAddonGroupValues.forEach(function (addonGroupValue) {
            totalAddonPrice += Number(addonGroupValue.price);
          }, this)
        }
      }

      const qty = this.selectedQty > 0 ? this.selectedQty : 1;
      return (Number(this.currentPrice) + totalAddonPrice) * qty;
    },
    /**
     * Finds a variant in Variants array with specified ID
     * TODO use an object with keys equal to variant id for quick lookup
     *
     * @return {} Variant
     */
    selectedVariantAddons() {
      let variantMatch = false;
      let variantId = this.selectedVariantId;
      this.config.variants.forEach(function (variant) {
        if (variantId == variant.id) {
          variantMatch = variant;
        }
      });
      return variantMatch.addons;
    },
    selectedAttributes() {
      return this.config.attributes;
    },
    /**
     * Returns an array of selected attribute options
     *
     * @return {array}
     */
    selectedOptions() {
      let options = [];

      if (this.config.optionAttributes) {
        Object.keys(this.config.optionAttributes).forEach(function (key) {
          if (this.hiddenAttributes.indexOf(key) === -1 && this.invalidVariantAttributes.indexOf(key) === -1) {
            let attribute = this.config.optionAttributes[(key)];
            if (attribute.selected) {
              let optionAttribute = attribute.options[(attribute.selected)];
              if (optionAttribute) {
                options.push({
                  attribute: attribute.label ?? key,
                  value: optionAttribute.label ?? optionAttribute.value,
                  attributeId: attribute.id,
                  valueId: optionAttribute.id
                })
              }
            }
          }

        }.bind(this));
      }
      return options;
    },
    selectedAddons() {
      let addons = [];
      if (this.config.addonAttributes) {
        Object.keys(this.config.addonAttributes).forEach(function (key) {
          if (this.hiddenAttributes.indexOf(key) === -1 && this.invalidVariantAttributes.indexOf(key) === -1) {
            let attribute = this.config.addonAttributes[(key)];
            if (attribute.selected) {
              let addonAttribute = attribute.options[(attribute.selected)];
              if (addonAttribute) {
                addons = {...addons, [attribute.name]: addonAttribute}
              }
            }
          }

        }.bind(this));
      }
      return addons;
    },
    selectedAddonIds() {
      let addonIds = [];
      if (this.config.addonAttributes) {
        Object.keys(this.config.addonAttributes).forEach(function (key) {
          if (this.hiddenAttributes.indexOf(key) === -1) {
            let attribute = this.config.addonAttributes[(key)];
            if (attribute.selected) {
              let addonAttribute = attribute.options[(attribute.selected)];
              if (addonAttribute) {
                addonIds.push(addonAttribute.addonId)
              }
            }
          }

        }.bind(this));
      }
      return addonIds;
    }
  },
  methods: {
    init() {
      window.threekitPlayer({
        authToken: this.authToken,
        el: document.getElementById("player"),
        assetId: this.threekitProductId,
        showShare: false,
        showHelp: false,
        allowMobileVerticalOrbit: false,
        onLoadingProgress: (progress) => {
          if (progress === 1) {
            this.playerloaded = true;
          }
        },
        cache: {
          maxAge: 500,
          scope: "v1.0",
        },
      }).then(function (player) {
        this.player = player;
        const configurator = this.player.getConfigurator()

        configurator.then(function (configurator) {
          this.attributes = configurator.getAttributes();
        }.bind(this));

        this.initConfig();
        this.setConditionals();
        this.deselectHiddenAttributes();

      }.bind(this));
    },
    initConfig() {

      this.isPlayerLoading = true;
      const configurator = this.player.getConfigurator()

      // Set the selected attributes on config.attributes

      Object.keys(this.config.defaultVariant.attributes).forEach(function (key) {
        let attribute = this.config.defaultVariant.attributes[key];
        if (attribute) {
          this.config.attributes[key].selected = attribute.value;
        }
      }.bind(this))

      // Set the selected multi attributes on config.attributes

      Object.keys(this.config.defaultVariant.multiAttributes).forEach(function (key) {
        let attribute = this.config.defaultVariant.multiAttributes[key];
        if (attribute) {
          this.config.multiAttributes[key].selected = attribute.value;
        }
      }.bind(this))

      // Initialize the config of the player with the default variant attributes

      let initialConfig = {...this.getSelectedAttributes(), ...this.getSelectedOptionAttributes(), ...this.getSelectedAddonAttributes()};

      console.log('Setting Initial ThreeKit Config: ', initialConfig);


      configurator.then(function (configurator) {
        configurator.setConfiguration(initialConfig).then(function () {
          // Zoom to fit camera on object
          this.player.camera.frameBoundingSphere();
          this.loaded = true;
          this.isPlayerLoading = false;

        }.bind(this));
      }.bind(this));
    },
    /**
     * Checks for attribute value overirde for selected variant
     *
     *
     * @return none
     */
    getAttributeLabel(valLabel, attrName, valName) {

      let label = valLabel;
      let attributeOverrides = this.config.attributeValueLabelOverrides[(attrName)];

      if (!attributeOverrides) {
        return label;
      }

      attributeOverrides.forEach(function (item) {
        if (valName == item.targetAttributeValue) {
          let selectedAttribute = this.getSelectedAttribute(item.sourceAttribute, false);
          // Check if source attribute has source attribute value selected
          if (selectedAttribute == item.sourceValue) {
            label = item.label;
          }
        }
      }, this)

      return label;

    },
    getSelectedVariant() {
      return this.selectedVariantId ? this.variantsByVariantId[(this.selectedVariantId)] : false;
    },
    getValidSelectedVariantAddonGroups() {
      let validAddonGroupSelections = [];
      let selectedVariant = this.getSelectedVariant();

      if (selectedVariant && Object.keys(selectedVariant.addonGroups).length) {
        Object.keys(selectedVariant.addonGroups).forEach(function (key) {
          let invalidSelection = false;
          let addonGroupSelections = {};
          let addonGroup = selectedVariant.addonGroups[(key)];

          Object.keys(addonGroup.attributes).forEach(function (key) {
            let addonGroupAttribute = addonGroup.attributes[key];
            // Check if addon attribute has been selected
            if (Object.keys(this.selectedAddons).indexOf(addonGroupAttribute.name) !== -1) {
              let selectedAddon = this.selectedAddons[(addonGroupAttribute.name)];
              addonGroupSelections = {...addonGroupSelections, [addonGroupAttribute.name]: selectedAddon};
            } else {
              invalidSelection = true;
            }
          }, this);

          if (!invalidSelection && Object.keys(addonGroupSelections).length) {
            validAddonGroupSelections = {
              ...validAddonGroupSelections,
              [addonGroup.key]: {
                'addons': addonGroupSelections,
                'key': this.generateAddonGroupAttributeKey(addonGroupSelections)
              }
            }
          }
        }, this);
      }

      return validAddonGroupSelections;
    },
    getValidSelectedAddonGroupValues() {
      let selectedVariant = this.getSelectedVariant();
      let selectedAddonGroups = this.getValidSelectedVariantAddonGroups();
      let addonGroupValues = [];
      if (Object.values(selectedAddonGroups).length) {
        Object.keys(selectedAddonGroups).forEach(function (key) {
          let addonGroup = selectedAddonGroups[(key)];

          // Check if values key from addon group exists in variant.addonPricing
          let addonPricing = selectedVariant.addonPricing;
          let addonGroupPricingMatch = addonPricing[(key)];

          if (addonGroupPricingMatch && addonGroupPricingMatch[(addonGroup.key)]) {
            let addonGroupValueMatch = addonGroupPricingMatch[(addonGroup.key)];
            addonGroupValues = [...addonGroupValues, addonGroupValueMatch];
          }
        }.bind(this));
      }

      return addonGroupValues;
    },
    generateAddonGroupAttributeKey(addons) {
      let addonValues = [];
      let attributeOrder = this.config.attributeSortOrder;
      let addonArray = Object.values(addons);

      // Sort the addons by the main attribute sort order to keep consistent keys
      addonArray.sort((a, b) => attributeOrder.indexOf(a.attributeName) - attributeOrder.indexOf(b.attributeName));

      addonArray.forEach(function (addon) {
        addonValues.push(addon.value);
      })
      return addonValues.join(':')
    },
    /**
     * Checks all selected attributes and if an attribute value or its parent attribute is hidden then set selected to false
     *
     * @return none
     */
    deselectHiddenAttributes() {

      let threekitConfigReset = {};

      // Multi Attributes TODO clean code
      Object.keys(this.config.multiAttributes).forEach(function (key) {
        let attribute = this.config.multiAttributes[key];
        if (this.hiddenAttributes.indexOf(attribute.name) !== -1) {
          this.config.multiAttributes[key].selected = '';
        }

        // If attribute has hidden values
        if (Object.keys(this.hiddenAttributeValuesMapped).indexOf(attribute.name) !== -1) {
          let hiddenAttributeValues = this.hiddenAttributeValuesMapped[(attribute.name)];
          let selectedAttributeValue = this.config.multiAttributes[key].selected;

          // If selected attribute value is in hidden values mapped to attribute
          if (hiddenAttributeValues.indexOf(selectedAttributeValue) !== -1) {
            this.config.multiAttributes[key].selected = '';
          }
        }

      }.bind(this))

      // Basic Attributes
      Object.keys(this.config.attributes).forEach(function (key) {
        let attribute = this.config.attributes[key];
        if (this.hiddenAttributes.indexOf(attribute.name) !== -1) {
          threekitConfigReset = {...threekitConfigReset, [key]: this.config.attributes[key].selected}

          this.config.attributes[key].selected = '';
        }

        // If attribute has hidden values
        if (Object.keys(this.hiddenAttributeValuesMapped).indexOf(attribute.name) !== -1) {
          let hiddenAttributeValues = this.hiddenAttributeValuesMapped[(attribute.name)];
          let selectedAttributeValue = this.config.attributes[key].selected;

          // If selected attribute value is in hidden values mapped to attribute
          if (hiddenAttributeValues.indexOf(selectedAttributeValue) !== -1) {
            threekitConfigReset = {...threekitConfigReset, [key]: this.config.attributes[key].selected}
            this.config.attributes[key].selected = '';
          }
        }
      }.bind(this))

      // Addon Attributes
      Object.keys(this.config.addonAttributes).forEach(function (key) {
        let attribute = this.config.addonAttributes[key];
        if (this.hiddenAttributes.indexOf(attribute.name) !== -1) {
          threekitConfigReset = {...threekitConfigReset, [key]: this.config.addonAttributes[key].selected}

          this.config.addonAttributes[key].selected = '';
        }

        // If attribute has hidden values
        if (Object.keys(this.hiddenAttributeValuesMapped).indexOf(attribute.name) !== -1) {
          let hiddenAttributeValues = this.hiddenAttributeValuesMapped[(attribute.name)];
          let selectedAttributeValue = this.config.addonAttributes[key].selected;

          // If selected attribute value is in hidden values mapped to attribute
          if (hiddenAttributeValues.indexOf(selectedAttributeValue) !== -1) {
            threekitConfigReset = {...threekitConfigReset, [key]: this.config.addonAttributes[key].selected}
            this.config.addonAttributes[key].selected = '';
          }
        }
      }.bind(this))

      // Addon Attributes
      Object.keys(this.config.optionAttributes).forEach(function (key) {
        let attribute = this.config.optionAttributes[key];
        if (this.hiddenAttributes.indexOf(attribute.name) !== -1) {
          threekitConfigReset = {...threekitConfigReset, [key]: this.config.optionAttributes[key].selected}

          this.config.optionAttributes[key].selected = '';
        }

        // If attribute has hidden values
        if (Object.keys(this.hiddenAttributeValuesMapped).indexOf(attribute.name) !== -1) {
          let hiddenAttributeValues = this.hiddenAttributeValuesMapped[(attribute.name)];
          let selectedAttributeValue = this.config.optionAttributes[key].selected;

          // If selected attribute value is in hidden values mapped to attribute
          if (hiddenAttributeValues.indexOf(selectedAttributeValue) !== -1) {
            threekitConfigReset = {...threekitConfigReset, [key]: this.config.optionAttributes[key].selected}
            this.config.optionAttributes[key].selected = '';
          }
        }
      }.bind(this))

    },

    /**
     * Updates threekit player configurator
     *
     * @param {array} Config values
     * @return none
     */
    setConfig(config) {
      // Parse out active multi attributes to exclude from hidden attribute application
      // TODO restructure data so displayed fields don't have direct relationship to attribute name

      let ignoredHiddenAttributes = [];
      let selectedAttributes = this.getSelectedAttributes();

      Object.keys(this.config.multiAttributes).forEach(function (key) {
        let multiAttribute = this.config.multiAttributes[(key)];

        if (this.hiddenAttributes.indexOf(multiAttribute.name) == -1) {
          ignoredHiddenAttributes = [...ignoredHiddenAttributes, ...multiAttribute.childAttributes];
        }
      }, this);

      // Remove all hidden attributes from three kit config
      this.hiddenAttributes.forEach(function (hiddenAttribute) {
        // Check if multi attribute
        if (Object.keys(this.config.multiAttributes).indexOf(hiddenAttribute) !== -1) {
          let multiAttribute = this.config.multiAttributes[(hiddenAttribute)];
          // Reset child attributes IF not valid as main attributes
          multiAttribute.childAttributes.forEach(function (childAttribute) {
            if (ignoredHiddenAttributes.indexOf(childAttribute) == -1 && Object.keys(selectedAttributes).indexOf(childAttribute) == -1) {
              config = {...config, [childAttribute]: ''}
            }
          }, this)
        } else {
          if (ignoredHiddenAttributes.indexOf(hiddenAttribute) == -1) {
            config = {...config, [hiddenAttribute]: ''}
          }
        }
      }, this);

      const configurator = this.player.getConfigurator();

      this.isPlayerLoading = true;

      console.log('Updating ThreeKit Config: ', config);

      configurator.then(function (configurator) {

        configurator.setConfiguration(config).then(function () {
          // Zoom to fit camera on object
          this.player.camera.frameBoundingSphere();
          this.isPlayerLoading = false;

        }.bind(this));
      }.bind(this));
    },
    /**
     * Sets this.hiddenAttributeValuesMapped and this.hiddenAttributeValues by iterating over all conditions.attributes and conditions.attributeValues and matching attributes to selected attributes
     */
    setConditionals() {
      let hiddenAttributes = [];

      // Full Attribute Conditionals

      this.config.conditions.attributes.forEach(function (condition) {
        let attributeName = condition.sourceAttribute;
        let attribute = this.config.attributes[attributeName] ?? this.config.addonAttributes[attributeName] ?? this.config.multiAttributes[attributeName];

        if (attribute) {
          if (attribute.selected === condition.sourceValue) {
            hiddenAttributes = [...hiddenAttributes, condition.targetAttribute]
          }
        }
      }.bind(this));

      this.hiddenAttributes = hiddenAttributes;

      // Attribute Value Conditionals

      let hiddenAttributeValues = [];
      let hiddenAttributeValuesMapped = [];

      Object.keys(this.config.conditions.attributeValues).forEach(function (conditionAttributeName) {

        let attributeConditions = this.config.conditions.attributeValues[conditionAttributeName];
        attributeConditions.forEach(function (condition) {

          let attributeName = condition.sourceAttribute;
          let attribute = this.config.attributes[attributeName] ?? this.config.addonAttributes[attributeName] ?? this.config.multiAttributes[attributeName];

          if (attribute) {
            if (attribute.selected === condition.sourceValue) {
              hiddenAttributeValues = [...hiddenAttributeValues, ...condition.targetAttributeValues]

              hiddenAttributeValuesMapped = {
                ...hiddenAttributeValuesMapped,
                [condition.targetAttribute]:
                    [...hiddenAttributeValuesMapped[condition.targetAttribute] ?? [], ...condition.targetAttributeValues]
              }
            }
          }

        }.bind(this))
      }.bind(this));

      this.hiddenAttributeValuesMapped = hiddenAttributeValuesMapped;
      this.hiddenAttributeValues = hiddenAttributeValues;
    },

    /**
     *
     */
    setMultiOption(attr, val, vals) {
      Object.keys(vals).forEach(function (key) {
        let attrVal = vals[(key)]
        this.setConfig({
          [attrVal.attribute]: attrVal.value
        });
      }, this);

      this.config.multiAttributes[attr].selected = val;
      this.setConditionals();
      this.deselectHiddenAttributes();

      this.selectRequiredAttributes();
      this.setProductVariant();
    },

    /**
     *
     */
    setOption(attr, val) {
      this.setConfig({
        [attr]: val
      });
      this.config.attributes[attr].selected = val;
      this.setConditionals();
      this.deselectHiddenAttributes();
      this.selectRequiredAttributes();
      this.setProductVariant();
    },

    /**
     *
     */
    setBasicOption(attr, val) {
      this.setConfig({
        [attr]: val
      });
      this.config.optionAttributes[attr].selected = val;
      this.setConditionals();
      this.deselectHiddenAttributes();
      this.selectRequiredAttributes();
    },

    /**
     *
     */
    setAddonOption(attr, val) {
      this.setConfig({
        [attr]: val
      });
      this.config.addonAttributes[attr].selected = val;
      this.setConditionals();
      this.deselectHiddenAttributes();
      this.selectRequiredAttributes();
    },

    /**
     *
     */
    getSelectedAttributes() {
      let selectedAttributes = {};

      Object.keys(this.config.attributes).forEach(function (key) {
        if (this.hiddenAttributes.indexOf(key) == -1) {
          let attribute = this.config.attributes[key];
          selectedAttributes = {...selectedAttributes, [key]: attribute.selected}
        }

      }.bind(this));

      return selectedAttributes;
    },

    /**
     * Returns an object with all option attribute selections that are not hidden
     * */
    getSelectedOptionAttributes() {
      let selectedAttributes = {};

      Object.keys(this.config.optionAttributes).forEach(function (key) {
        if (this.hiddenAttributes.indexOf(key) == -1) {
          let attribute = this.config.optionAttributes[key];
          selectedAttributes = {...selectedAttributes, [key]: attribute.selected}
        }
      }.bind(this));

      return selectedAttributes;
    },
    /**
     * Returns an object with all addon attribute selections that are not hidden
     */
    getSelectedAddonAttributes() {
      let selectedAttributes = {};

      Object.keys(this.config.addonAttributes).forEach(function (key) {
        if (this.hiddenAttributes.indexOf(key) == -1) {
          let attribute = this.config.addonAttributes[key];
          selectedAttributes = {...selectedAttributes, [key]: attribute.selected}
        }
      }.bind(this));

      return selectedAttributes;
    },
    /**
     * Selects first option on all unselected required main attributes
     */
    selectRequiredAttributes() {
      Object.keys(this.unselectedAttributes).forEach(function (key) {
        let requiredAttribute = this.unselectedAttributes[(key)];
        if (requiredAttribute) {
          let attribute = this.config.attributes[(requiredAttribute.name)] ?? this.config.multiAttributes[(requiredAttribute.name)] ?? this.config.addonAttributes[(requiredAttribute.name)] ?? this.config.optionAttributes[(requiredAttribute.name)];
          let hiddenAttributeValues = this.hiddenAttributeValuesMapped[(attribute.name)] ?? [];
          let appliedSelection = false;
          console.log('Setting required attribute:', attribute);

          // Set selected to first non-hidden option
          Object.keys(attribute.options).forEach(function (key) {
            let option = attribute.options[(key)];
            if (!appliedSelection && (hiddenAttributeValues.indexOf(option.value) == -1)) {
              attribute.selected = option.value;
              appliedSelection = true;

              console.log('Setting required attribute option:', option);

              // If multi attribute with child attributes, then we need to set threekit based on values of selected optipn
              if (attribute.childAttributes) {
                Object.keys(option.values).forEach(function (key) {
                  let attrVal = option.values[(key)]
                  this.setConfig({
                    [attrVal.attribute]: attrVal.value
                  });
                }, this);

              } else {
                // Update three kit config and update conditionals similar to what happens when a user selects an option but do not attempt to reselect variant
                this.setConfig({
                  [attribute.name]: option.value
                });
              }
              this.setConditionals();
            }
          }, this);
        }
      }, this);
    },
    /**
     * Creates a key based on current selection of Variant attributes and attempts to match it to a variant key
     */
    setProductVariant() {

      let selectedAttributes = {};
      let variantKey = '';

      // Create the selection variant key in the attribute order that was used when creating variants
      this.config.orderedMainAtrributes.forEach(function (orderedAttribute) {
        let attribute = this.config.attributes[(orderedAttribute.name)] ?? this.config.multiAttributes[(orderedAttribute.name)];
        if (attribute && this.hiddenAttributes.indexOf(attribute.name) === -1) {
          selectedAttributes = {...selectedAttributes, [attribute.name]: attribute.selected}
          variantKey = variantKey === '' ? attribute.selected : `${variantKey}:${attribute.selected}`;
        }
      }.bind(this));

      let matchedVariant = false;

      console.log('Selected Variant Key: ', variantKey);

      this.currentSelectionVariantKey = variantKey;

      // TODO create object that maps variants by keys
      // Iterate over all variants to match by created key
      this.config.variants.forEach(function (variant) {
        if (variant.key === variantKey) {
          matchedVariant = variant;
        }
      })

      if (matchedVariant) {
        this.invalidSelection = false;
        this.currentPrice = matchedVariant.price;
        this.selectedVariantId = matchedVariant.id;
        this.selectedVariant = matchedVariant;
      } else {
        this.invalidSelection = true;
        this.selectedVariantId = false;
      }
    },
    /**
     *
     */
    getSelectedAttributeMulti(attributeName) {
      let selected = this.config.multiAttributes[attributeName].selected;

      if (selected) {
        let selectedLabel = this.config.multiAttributes[attributeName].selected;
        let options = this.config.multiAttributes[attributeName].options;
        Object.keys(options).forEach(function (key) {
          let option = options[key];
          if (selected === option.value) {
            selectedLabel = option.label;
          }

        });
        return selectedLabel;
      } else {
        return 'Not Selected';
      }
    },
    /**
     *
     */
    getSelectedAttribute(attributeName, useLabel = true) {
      let selected = this.config.attributes[attributeName].selected;

      if (selected) {
        let selectedLabel = this.config.attributes[attributeName].selected;
        let selectedOption = false;
        let options = this.config.attributes[attributeName].options;
        Object.keys(options).forEach(function (key) {
          let option = options[key];

          if (selected === option.value) {
            selectedOption = option;
          }
        });

        // Check if we need to override label
        if (useLabel && selectedOption) {
          selectedLabel = this.getAttributeLabel(selectedOption.label, attributeName, selectedOption.value)
        }

        return selectedLabel;
      } else {
        return useLabel ? 'Not Selected' : false;
      }
    },
    /**
     *
     */
    getSelectedAttributeOption(attributeName) {

      let selected = this.config.optionAttributes[attributeName].selected;

      if (selected) {
        let selectedLabel = this.config.optionAttributes[attributeName].selected;

        let options = this.config.optionAttributes[attributeName].options;
        Object.keys(options).forEach(function (key) {
          let option = options[key];

          if (selected === option.value) {
            selectedLabel = option.label;
          }

        });
        return selectedLabel;
      } else {
        return 'Not Selected';
      }

    },
    /**
     *
     */
    getSelectedAttributeAddon(attributeName) {

      let selected = this.config.addonAttributes[attributeName].selected;

      if (selected) {
        let selectedLabel = this.config.addonAttributes[attributeName].selected;

        let options = this.config.addonAttributes[attributeName].options;
        Object.keys(options).forEach(function (key) {
          let option = options[key];

          if (selected === option.value) {
            selectedLabel = option.label;
          }

        });
        return selectedLabel;
      } else {
        return 'Not Selected';
      }

    },
    /**
     *
     */
    formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign +
            (j ? i.substr(0, j) + thousands : '') +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
            (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
      } catch (e) {
      }
    },
    // Test function possibly TODO later
    async createImage() {
      let image = new Image();
      let imgSrc = await this.player.snapshotAsync();
      image.src = imgSrc;
      this.snapshot = imgSrc;
    },
    getAttrValues(name) {
      return this.config.attributes[name] ? this.config.attributes[name].options : [];
    },
    getAddonAttrValues(name) {
      return this.config.addonAttributes[name] ? this.config.addonAttributes[name].options : [];
    },
    onQtyInput(e) {
      const element = e.target;
      const value = parseFloat(element.value === '' ? '0' : element.value.replace(',', '.'))

      if (!(value > 0)) {
        this.selectedQty = 1;
      } else if (value > 999) {
        this.selectedQty = 999;
      }
    }
  }
}
</script>


<style lang="scss" type="text/scss">

main {
  overflow: unset;
}

$primary: #2C9199;
$primary-dark: #2B2A28;
$primary-darker: #2B2A28;
$primary-light: rgba(188, 183, 179, 0.3);
$secondary: #2C9199;
$secondary-alt: #C4D82E;
$grey: #505a61;
$grey-dark: #2B2A28;
$grey-light: #F4F4F5;
$grey-alt: #b7b9bb;
$black: #000000;
$white: white;

.product-configurator {
  padding: 80px 0;

  .fixed-items {
    position: fixed;
    right: 30px;
    bottom: 30px;
    z-index: 3;
    color: #2B2A28;
    background: #fff;

    .current-price {
      display: inline-block;
      overflow: hidden;
      line-height: 43px;
      vertical-align: top;
      padding-left: 15px;
      transition: all ease-in-out 0.3s;
      visibility: hidden;
      position: absolute;
      width: 300px;
      right: 0;
      bottom: 0;
      border: 2px solid #2B2A28;
      border-right: 0;
      background: #fff;
      z-index: 1;
    }

    i {
      color: #2C9199;
      font-style: normal;
      font-weight: bold;
    }

    span {
      display: inline-block;
      color:#2C9199;
      font-size: 14px;
      font-weight: bold;
      padding-right: 15px;
      font-size: 16px;
    }

    .button {
      &.open-quote {
        position: relative;
        display: inline-block;
        background: white;
        border-color: #2C9199;
        color: #2C9199;
        text-decoration: none;
        box-shadow: 0 3px 12px rgba(0, 0, 0, 0.2);
        z-index: 2;
      }
    }
  }

  &__disclaimer {
    font-size: 12px;
    color: #2B2A28;
    border: 3px solid #2B2A28;
    text-align: center;
    line-height: 18px;
    padding: 10px 20px;
    margin-top: 20px;


    & span {
      position: relative;
      display: inline-block;
      padding-right: 10px;
      z-index: 1;
      line-height: normal;
      color: #fff;
    }
    
    & span::after {
      content: '';
      width: 0;
      height: 0;
      border-right: 11px solid transparent;
      border-bottom: 18px solid #2C9199;
      border-left: 11px solid transparent;
      display: block;
      position: absolute;
      top: -3px;
      left: -9px;
      z-index: -1;
    }
  }
}

@media (max-width:767px) {
  .current-price {
    border-right: 2px solid #2B2A28 !important;
  }
}

.product-configurator {

  position: relative;

  .pt-0 {
    padding-top: 0;
  }

  padding-top: 32px;

  &__player {
    position: sticky;
    top: 220px;
    border: 1px solid #ddd;
    margin-bottom: 64px;
  }

  &__content {
    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }


  &__container {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 1200px;
    position: relative;
    width: 90%;
    // overflow: hidden;
  }

  &__crumbs {
    margin-bottom: 16px;
    color: $primary-darker;

    a {
      color: $primary-darker;
    }
  }

  &__heading {
    margin-bottom: 20px;
  }

  h1 {
    margin-bottom: 0;
    color: $primary-darker;

    p {
      font-size: 40px;
      margin: 0;
      line-height: 1;
    }
  }

  @media (min-width: 768px) {
    .flex-row {


      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin: 0 -32px;

      .flex-col {
        padding: 0 32px;
      }
    }

  }

  w-full {
    width: 100%;
  }

  .md\:w-1\/2 {
    @media (min-width: 768px) {
      width: 50%;
    }
  }

  &__price {
    font-size: 40px;
    font-weight: 600;
    color: $primary;
    margin-bottom: 32px;
  }

  &__error-message {
    font-weight: 600;
    color: #c6c6c6;
    margin-bottom: 32px;
  }

  &__mobile-warning {
    color: #013b43;
    padding-bottom: 30px;
    display: none;
    @media (max-width:964px) {
      display: block;
    }
  }

  &__invalid {
    font-size: 40px;
    font-weight: 600;
    color: #c6c6c6;
    margin-bottom: 32px;
  }

  &__form-actions {
    display: flex;
  }

  &__qty {

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    width: 100px;
    margin-right: 12px;
    position: relative;

    input[type=number] {
      padding: 13px 14px;
      width: 100%;
      border: 2px solid $secondary;
      text-align: center;
      color: $primary-darker;
      font-weight: 600;
      -moz-appearance: textfield;
    }

    &__plus, &__minus {
      transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      display: flex;
      align-items: center;
      padding: 0 12px;
      height: calc(100% - 4px);
      font-size: 12px;
      cursor: pointer;
      position: absolute;
      top: 50%;
      user-select: none;
      transform: translateY(-50%);

      &:hover {
        color: $secondary;
        background-color: $grey-light;
      }
    }

    &__plus {
      right: 2px;

    }

    &__minus {
      left: 2px;
    }
  }


  &__attribute {
    margin-bottom: 24px;

    &__title {
      margin-bottom: 12px;
      color: $primary-darker;
      
      font-weight: bold;

      &__option-value {
        font-weight: 500;
        padding-left: 10px;
        text-transform: none;
      }
    }

    &__value {
      cursor: pointer;
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 10px;
      text-transform: none;
      user-select: none;
      font-size: 16px;
      padding: 10px 20px;
      color: $primary-darker;
      outline: 2px solid $grey-alt;
      transition: all 0.15s ease-in-out;

      &.img-value {
        height: 40px;
        width: 40px;
        background-size: cover;
        position: relative;
        padding: 0;
      }

      &__img {
        background-position: center;
        background-size: cover;
        position: absolute;
        width: 85%;
        height: 85%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      &.active {
        outline: 3px solid $primary;
      }

      &:hover {
        background-color: $grey-light;
      }

    }

    &__values {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  &__form {
    margin-top: 40px;
  }

  .button {
    border-radius: 0;
    line-height: 1;
    font-size: 15px;
    padding: 14px 32px;

    &--atc {
      padding: 14px 55px;
    }


    &:disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}


</style>
